import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

interface Notification {
  id: string;
  type: string;
  title: string;
  message: string;
  read: boolean;
  metadata: Record<string, unknown> | null;
  createdAt: string;
}



export const useNotifications = () => {
  return useQuery({
    queryKey: ["portal-notifications"],
    queryFn: async () => {
      const { data } = await api.get("/portal/notifications");
      return data as Notification[];
    },
    refetchInterval: 30_000,
  });
}



export const useUnreadCount = () => {
  return useQuery({
    queryKey: ["portal-notifications", "unread-count"],
    queryFn: async () => {
      const { data } = await api.get("/portal/notifications/unread-count");
      return data as { count: number };
    },
    refetchInterval: 30_000,
  });
}



export const useMarkAsRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.patch(`/portal/notifications/${id}/read`);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["portal-notifications"] });
      qc.invalidateQueries({ queryKey: ["portal-notifications", "unread-count"] });
    },
  });
}



export const useMarkAllAsRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      await api.patch("/portal/notifications/read-all");
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["portal-notifications"] });
      qc.invalidateQueries({ queryKey: ["portal-notifications", "unread-count"] });
    },
  });
}



export const useDeleteNotification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/portal/notifications/${id}`);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["portal-notifications"] });
      qc.invalidateQueries({ queryKey: ["portal-notifications", "unread-count"] });
    },
  });
}



export const useDeleteReadNotifications = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      await api.delete("/portal/notifications/read");
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["portal-notifications"] });
      qc.invalidateQueries({ queryKey: ["portal-notifications", "unread-count"] });
    },
  });
}
